module.exports = __webpack_public_path__ + "img/btn_min_bookmark.84fbc061.svg";